import { useState } from 'react';
import { Box, Paper, Typography, Collapse } from '@mui/material';

export const WelcomeMessage = () => {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    setExpanded(!expanded);
  };
  const shadow = expanded
    ? { pb: 2 }
    : {
        boxShadow: 'inset 0px -11px 8px -10px #CCC',
      };
  return (
    <Paper sx={{ mb: 4 }}>
      <Collapse
        onClick={handleToggle}
        in={expanded}
        collapsedSize={130}
        sx={{
          px: 2,
          pt: 2,
          background: 'rgba(246,207,0,0.21)',
          ...shadow,
        }}
      >
        <Typography
          variant={'handwriting'}
          sx={{ fontSize: 20, color: 'gray' }}
          gutterBottom
        >
          Dear valued client,
        </Typography>
        <br />
        <Typography variant={'caption'}>
          At Dr. Vella's Clinic, we're deeply <strong>committed</strong> to
          offering exceptional aesthetic care. Dr. Francesca Vella and our
          dedicated team aim to ensure your visit not only meets but{' '}
          <strong>exceeds your expectations</strong>. Your insights are
          incredibly valuable to us and to individuals contemplating our
          services. If you're pleased with your experience, we'd be{' '}
          <strong>grateful</strong> if you could share your feedback. Your
          review can significantly influence and guide others considering their
          aesthetic options.
          <br />
          <br />
          Thank you for your trust and support.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Typography
            variant={'handwriting'}
            sx={{ fontSize: 30, color: 'gray' }}
          >
            Dr. Francesca Vella
          </Typography>
        </Box>
      </Collapse>
    </Paper>
  );
};
